<template>
    <custom-header :active="'home'" class="w-full"></custom-header>
    <main>
        <section class="background-main flex items-center text-center"></section>
        <section class="flex items-center text-center justify-center">
            <div class="flex flex-col gap-8 w-full mx-30-vh">
                <div class="m-h-50 grid_border p-12 bg-opacity h-full" :style="`background-image: url(${card.background}); background-size: cover`">
                    <div style="min-height: inherit">
                        <div class="flex flex-row items-center justify-center gap-4">
                            <img :src="card.image" width="96" height="96" />
                            <p class="text-xl font-carter-one">{{ card.title }}</p>
                        </div>
                        <div class="flex flex-col items-center text-center justify-center h-full" style="min-height: inherit">
                            <p class="text-xl font-carter-one">{{ card.description }}</p>
                        </div>
                    </div>
                </div>
                <router-link :to="{name: 'news'}" class="btn" style="background-color: #3b5b90; color: white"> Zu den Neuigkeiten </router-link>
            </div>
        </section>
        <section>
            <img src="@/assets/images/bilduntenohneschatten.png" style="width: 100%" />
        </section>
    </main>
    <custom-footer></custom-footer>
</template>

<style>
.background-main {
    background-image: url('@/assets/images/startseiteobenohneschatten.png');
    background-repeat: no-repeat;
    height: 725px;
    background-position: center;
    background-size: cover;
    position: relative;
    width: 100%;
    z-index: 1;
}
.center-image-main {
    width: fit-content;
    position: absolute;
    left: 10vw;
    transform: translateY(-30%);
    color: white;
}
.grid_border {
    border-width: 5px;
    border-color: #4a7dac;
    border-radius: 1.5rem;
}
@media (max-width: 768px) {
    .center-image-main {
        width: fit-content;
        position: static;
        margin: auto;
    }
}
</style>

<script>
import CustomHeader from '../components/header.vue';
import CustomFooter from '../components/footer.vue';

export default {
    name: 'Home',
    components: {
        CustomHeader,
        CustomFooter,
    },
    data() {
        return {
            card: {
                background: 'https://cdn.discordapp.com/attachments/714511020885934160/1126623395438661712/9pgq_leds_210408.jpg',
                image: 'https://cloud.henrikdev.xyz/project_v_queens/PV_LOGO_picturemark_black.png',
                title: 'Acker oder Wiese für Hundeplatz gesucht',
                description: 'Wir suchen aktuell noch nach einer Wiese der einem Acker für ienen Hundeplatz.',
            },
        };
    },
    methods: {
        upperCase(text) {
            let return_text = '';
            const split_string = text.split('');
            for (const split of split_string) {
                if (split === split.toUpperCase() && split != ' ') return_text += `<small class='upper'>${split}</small>`;
                else return_text += split;
            }
            return return_text;
        },
    },
};
</script>
